/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    acptNo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    acptDtlNo?: Array<string>;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    orderConfirmContents?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    tel?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    businessHourTitle1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    businessHour1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    businessHourTitle2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse
     */
    businessHour2?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acptNo': !exists(json, 'acptNo') ? undefined : json['acptNo'],
        'acptDtlNo': !exists(json, 'acptDtlNo') ? undefined : json['acptDtlNo'],
        'orderConfirmContents': !exists(json, 'orderConfirmContents') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSON(json['orderConfirmContents']),
        'tel': !exists(json, 'tel') ? undefined : json['tel'],
        'businessHourTitle1': !exists(json, 'businessHourTitle1') ? undefined : json['businessHourTitle1'],
        'businessHour1': !exists(json, 'businessHour1') ? undefined : json['businessHour1'],
        'businessHourTitle2': !exists(json, 'businessHourTitle2') ? undefined : json['businessHourTitle2'],
        'businessHour2': !exists(json, 'businessHour2') ? undefined : json['businessHour2'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acptNo': value.acptNo,
        'acptDtlNo': value.acptDtlNo,
        'orderConfirmContents': JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsToJSON(value.orderConfirmContents),
        'tel': value.tel,
        'businessHourTitle1': value.businessHourTitle1,
        'businessHour1': value.businessHour1,
        'businessHourTitle2': value.businessHourTitle2,
        'businessHour2': value.businessHour2,
    };
}

